export const label = [
  {
    title: "Участник",
    dataIndex: "name",
    key: "name",
    width: 350,
  },
  {
    title: "Основная ставка",
    dataIndex: "baseFee",
    key: "commission",
    width: 190,
  },
  {
    title: "Комиссия за эквайринг",
    dataIndex: "acquiringFee",
    key: "acquiringFee",
    width: 190,
  },
  {
    title: "За платёжного агента",
    dataIndex: "agentFee",
    key: "agentFee",
    width: 190,
  },
  {
    title: "За доп. заявки",
    dataIndex: "additionalRequestsFee",
    key: "additionalRequestsFee",
    width: 190,
  },
  {
    title: "Скидка за сумму",
    dataIndex: "amountDiscount",
    key: "amountDiscount",
    width: 190,
  },
  {
    title: "Порог для скидки",
    dataIndex: "discountThreshold",
    key: "discountThreshold",
    width: 190,
  },
];
